/* Quick-Add mit Mengenauswahl – Buonissimo (Theme: Sydney) */
(function () {
  'use strict';

  var CONFIG = {
    // Nur als Fallback – die Sections werden vorrangig vom Theme selbst erfragt
    sections: ['cart-drawer', 'cart-icon-bubble'],
    cartSelector: 'cart-drawer, cart-notification, #CartDrawer, .cart-drawer, .drawer--cart',
    countSelector: '.cart-count-bubble span, .cart-count-bubble, [data-cart-count], .cart-count',
    resetAfter: 1800
  };

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  /* ---------- Interaktion ---------- */
  // Capture-Phase: liegt über den Overlay-Links der Karte.
  document.addEventListener('click', function (event) {
    var box = event.target.closest('.bo-quick-add');
    if (!box) return;

    // Das Dropdown muss sich normal öffnen können
    if (event.target.closest('.bo-quick-add__select')) {
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var options = event.target.closest('[data-bo-options]');
    if (options) return openOptions(box, options);

    var add = event.target.closest('[data-bo-add]');
    if (add) addToCart(add);
  }, true);

  function toInt(value) { var n = parseInt(value, 10); return isNaN(n) ? 0 : n; }

  // Varianten-Produkte: vorhandene Quick-View des Themes nutzen, sonst Produktseite
  function openOptions(box, button) {
    var card = box.closest('.card-wrapper');
    var opener = card && card.querySelector('modal-opener button');
    if (opener) return opener.click();
    window.location.href = button.dataset.boUrl;
  }

  /* ---------- Warenkorb ---------- */

  // Das Theme-eigene Warenkorb-Element (Dawn-Linie: <cart-drawer> bzw. <cart-notification>)
  function getCartElement() {
    return document.querySelector(CONFIG.cartSelector);
  }

  // Genau die Sections anfordern, die das Theme selbst nach einem Add neu rendert
  function getSectionIds() {
    var cart = getCartElement();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
        if (ids.length) return ids;
      } catch (error) { /* Fallback unten */ }
    }
    return CONFIG.sections;
  }

  function addToCart(button) {
    if (button.classList.contains('is-loading')) return;

    var box = button.closest('.bo-quick-add');
    var field = box.querySelector('.bo-quick-add__select, .bo-quick-add__input');
    var quantity = field ? Math.max(toInt(field.value), 1) : 1;

    button.classList.remove('is-done', 'is-error');
    button.classList.add('is-loading');

    fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: quantity }],
        sections: getSectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Fehler');
          return data;
        });
      })
      .then(function (data) {
        button.classList.add('is-done');
        if (field) field.value = '1';
        document.dispatchEvent(new CustomEvent('bo-quick-add:added', { bubbles: true, detail: data }));
        showCart(data);
      })
      .catch(function (error) {
        button.classList.add('is-error');
        button.setAttribute('title', 'Konnte nicht hinzugefügt werden');
        console.warn('[bo-quick-add]', error);
      })
      .then(function () {
        button.classList.remove('is-loading');
        setTimeout(function () {
          button.classList.remove('is-done', 'is-error');
          button.setAttribute('title', 'In den Warenkorb');
        }, CONFIG.resetAfter);
      });
  }

  // 1. Weg: das Theme rendert und öffnet den Drawer selbst (Dawn-API)
  // 2. Weg: Sections aus der Antwort selbst einsetzen
  // 3. Weg: Drawer-Section frisch nachladen
  function showCart(data) {
    var cart = getCartElement();

    if (cart && typeof cart.renderContents === 'function' && data && data.sections) {
      try {
        cart.renderContents(data);
        return;
      } catch (error) {
        console.warn('[bo-quick-add] renderContents fehlgeschlagen, nutze Fallback', error);
      }
    }

    var replaced = data && data.sections ? updateSections(data.sections) : 0;
    if (replaced) {
      refreshCount();
      openCartDrawer();
      return;
    }

    reloadCartSection();
  }

  function updateSections(sections) {
    var parser = new DOMParser();
    var replaced = 0;

    Object.keys(sections).forEach(function (name) {
      var html = sections[name];
      var target = document.getElementById('shopify-section-' + name) ||
                   document.querySelector('[data-section-name="' + name + '"]') ||
                   document.getElementById(name);
      if (!target || !html) return;

      var doc = parser.parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + name) || doc.body.firstElementChild;
      if (!fresh) return;

      target.innerHTML = fresh.innerHTML;
      replaced++;
    });

    return replaced;
  }

  // Sicherheitsnetz: Section-ID des Drawers aus dem DOM ermitteln und frisch holen
  function reloadCartSection() {
    var cart = getCartElement();
    var wrapper = cart && cart.closest('[id^="shopify-section-"]');

    if (!wrapper) {
      refreshCount();
      openCartDrawer();
      return;
    }

    var id = wrapper.id.replace('shopify-section-', '');

    fetch(ROOT + '/?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
        if (fresh) wrapper.innerHTML = fresh.innerHTML;
      })
      .catch(function (error) { console.warn('[bo-quick-add] Drawer-Reload', error); })
      .then(function () {
        refreshCount();
        openCartDrawer();
      });
  }

  function refreshCount() {
    fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(CONFIG.countSelector).forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var cart = getCartElement();

    if (cart) {
      var inner = cart.querySelector('.drawer__inner, .cart-drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      if (typeof cart.open === 'function') return cart.open();
      if (typeof cart.show === 'function') return cart.show();
      cart.classList.add('active', 'is-open', 'animate');
      document.body.classList.add('overflow-hidden');
      return;
    }

    ['cart:open', 'cart-drawer:open', 'drawer:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    var trigger = document.querySelector('#cart-icon-bubble, .header__icon--cart');
    if (trigger) trigger.click();
  }
})();